
export function keyify(array: any[]) {
    for(var i=0;i<array.length;i++) {
        if (!array[i].key) array[i].key = Math.random();
    }
}

export function newID(): string {
    return String(Math.random()).substring(2) + "-" + (new Date().getTime());
}

export function generateUniqueShortID(uniqueWithinArray: any[], prop: string, prefix?: string): string {
    for(var i=0;i<1000000;i++) {
        var result = String(i);
        if (prefix) result = prefix + result;

        var found = false;
        for(var j=0;j<uniqueWithinArray.length;j++) {
            if (uniqueWithinArray[j][prop] === result) {
                found = true;
                break;
            }
        }

        if (!found) return result;
    }
    return newID();
}
